module.exports = __webpack_public_path__ + "img/title.0bd98ca0.webp";